module.exports = __webpack_public_path__ + "static/media/lifting_belt.c02ef52c.png";